import { Buttons, FlexContainer, Inputs, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { GradientBg, AuthContainer } from 'Components/UI';
import { routes } from 'Constants/routes';
import Form from './components';
import { defaultProps, SignUpStepTwoViewProps } from './types';

const View = ({ email }: SignUpStepTwoViewProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.AUTH);
  return (
    <GradientBg>
      <AuthContainer>
        <FlexContainer direction="column" gap="dimension_24">
          <Text color="dark" type="headline" size="S_L_S" align="center">
            {t('SignUp.stepTwo.title')}
          </Text>
          {email && <Inputs.Text value={email} readOnly label={t('Auth.signUp.labelEmail')} />}
          <Form />
          <FlexContainer justify="center" align="center" gap="dimension_08">
            <Text type="paragraphs" size="M_S_S" color="dark">
              {t('Auth.signUp.haveAccount')}
            </Text>
            <Buttons.Tiny
              label={t('Auth.signUp.login')}
              onClick={() => history.push(routes.SIGNIN)}
              mode="default"
            />
          </FlexContainer>
        </FlexContainer>
      </AuthContainer>
    </GradientBg>
  );
};

View.defaultProps = defaultProps;

export default View;
